seedWebApp.controller('DicsController', ['$scope', 'DicService', 'ToastService',
    function ($scope, DicService, ToastService) {

        $scope.prefs = {
            name: 'DicsGrid',
            sortByCol: null,
            canAdd: false,
            canEdit: true,
            canDelete: false
        };

        $scope.loadService = DicService.getDics;
        $scope.loadColumns = DicService.getDicsColumns;
        $scope.resetService = DicService.resetCache;


        $scope.qtStockClass = function (item) {
            return 'qt-stocks';
        };

        $scope.qtPOClass = function (item) {
            return 'qt-pos';
        };

        $scope.materialTypeClass = function (item) {
            if (item == 'CADASTRAR') {
                return 'material-type-to-insert';
            }
        };

        $scope.columns = [
            { name: 'DicID', display: 'Código', customClass: function () { return 'agp-color'; }, filterOptions: [], width: 10, isKey: true },
            { name: 'DicName', display: 'Nome', filterOptions: [], limitTo: '35', width: 15 },
            { name: 'DicType', display: 'Tipo', filterOptions: [], limitTo: '35', width: 15, customClass: $scope.qtStockClass },
            { name: 'DicDescription', display: 'Descrição', filterOptions: [], limitTo: '35', width: 15 },
            { name: 'ExtTableName', display: 'Integrações', filterOptions: [], width: 5, customClass: $scope.qtPOClass },
            { name: 'ParentTable', display: 'Parent', filterOptions: [], width: 5 },            
            { name: 'QtDics', display: '# Campos', filterOptions: [], width: 5 },
        ];

        $scope.insertNew = function () {
            DicService.openDicModal();
        }

        $scope.prefs.customEdit = function (item) {
            DicService.openDicModal(item.DicID);
        };
        
        $scope.getTotal = function () {
            $scope.loadingTotal = true;
            DicService.getDicsCount().then(function (response) {
                $scope.loadingTotal = false;
                $scope.totalItems = response.data;
            });
        };

        $scope.getTotal();

        $scope.searchMode = function () {
            $scope.$broadcast('inputSearch', $scope.filterString);
        };

        $scope.doRefresh = function () {
            $scope.$broadcast('refreshServiceGrid');
        };

        $scope.toExcel = function () {
            $scope.$broadcast('toExcel', 'dics');
        };

        $scope.rebuildAll = function () {
            var toastID = ToastService.createToast('Rebuild...', '', 0, 'wait');
            $scope.executing = true;
            DicService.rebuildAll().then(function (response) {
                ToastService.updateToast(toastID, 'Rebuild ok!', '', 4000, 'success');
                $scope.executing = false;
                $scope.doRefresh();
            },
                function (error) {
                    $scope.saving = false;
                    ToastService.updateToast(toastID, 'Erro rebuild!', '', 4000, 'error');
                });
        };

}]);
